var _rect, _rect2, _rect3, _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTurnPhoneToHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    rx: 10,
    fill: "#0F90FF",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30.1555,
    y: 14,
    width: 14.9333,
    height: 28,
    rx: 3,
    stroke: "#0F90FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2 4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 42,
    width: 14.9333,
    height: 28.6222,
    rx: 3,
    transform: "rotate(-90 9 42)",
    fill: "white",
    stroke: "#0F90FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2131 15C21.7091 15 18.8686 17.8405 18.8686 21.3444V22.9262L19.9394 21.7929C20.1346 21.5976 20.4512 21.5976 20.6465 21.7929C20.8417 21.9882 20.8417 22.3047 20.6465 22.5L18.7222 24.4869C18.5269 24.6821 18.2103 24.6821 18.0151 24.4869L16.1465 22.5C15.9512 22.3047 15.9512 21.9882 16.1465 21.7929C16.3417 21.5976 16.6583 21.5976 16.8536 21.7929L17.8686 22.9262V21.3444C17.8686 17.2882 21.1569 14 25.2131 14C25.4892 14 25.7131 14.2239 25.7131 14.5C25.7131 14.7761 25.4892 15 25.2131 15Z",
    fill: "#0F90FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.2001,
    cy: 34.8445,
    r: 0.933333,
    fill: "#0F90FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurnPhoneToHorizontal);
export default __webpack_public_path__ + "static/media/turnPhoneToHorizontal.99b2efdfab6541f04f6f2a914e925e44.svg";
export { ForwardRef as ReactComponent };